export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getQiniuToken: function getQiniuToken() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        // url: "/api/tools/getToken",
        url: "/api/v3/upload/getToken",
        method: "get",
        params: data
      });
    },
    getQiniuTokenByPHP: function getQiniuTokenByPHP() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/tools/getToken",
        method: "get",
        params: data
      });
    },
    siteVerify: function siteVerify() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/tools/siteVerify",
        method: "post",
        data: data
      });
    },
    getChartData: function getChartData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/analysis/chart/",
        method: "get",
        params: data
      });
    },
    //获取运营负责审核报表
    getOperationChartData: function getOperationChartData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/operationalWork",
        method: "post",
        data: data
      });
    },
    getAnalysisStatistics: function getAnalysisStatistics() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/common/statistics",
        method: "get",
        params: data
      });
    },
    getAnalysisHouseComplexAudit: function getAnalysisHouseComplexAudit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/house/complexAudit",
        method: "get",
        params: data
      });
    },
    getAnalysisAuditHouseErrorRate: function getAnalysisAuditHouseErrorRate() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/house/auditHouseErrorRate",
        method: "get",
        params: data
      });
    },
    getAnalysisChart: function getAnalysisChart() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/chart",
        method: "get",
        params: data
      });
    },
    generateWechatQrcode: function generateWechatQrcode() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/tools/qrcode/wechat/generate/",
        method: "get",
        params: data
      });
    },
    getUserDeviceRisk: function getUserDeviceRisk() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/device/risk",
        method: "get",
        params: data
      });
    },
    getUserDeviceRiskBatch: function getUserDeviceRiskBatch() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v1/admin/user/device/risk/batch",
        method: "get",
        params: data
      });
    },
    getPostChartData: function getPostChartData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/dwChart",
        method: "get",
        params: data
      });
    },
    getPostChartDataByDistinct: function getPostChartDataByDistinct() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/analysis/dwChartCountByDistinct",
        method: "get",
        params: data
      });
    }
  };
});